import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload, OrderingPayload, PaginatedResponse, PaginationPayload } from "../common_types";

import { Report, ReportGenerator, ReportGeneratorState, ReportsActionTypes, ReportsPayload } from "./types";

export const reportsFetchRequest = (payload: ReportsPayload & PaginationPayload & OrderingPayload & GatePayload) =>
  action(ReportsActionTypes.FETCH_REQUEST, payload);
export const reportsFetchSuccess = (payload: PaginatedResponse<Report>) =>
  action(ReportsActionTypes.FETCH_SUCCESS, payload);
export const reportsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ReportsActionTypes.FETCH_ERROR, errorMessage);
};

export const reportGeneratorStartSuccess = (payload: ReportGenerator) =>
  action(ReportsActionTypes.REPORT_GENERATOR_START_SUCCESS, payload);
export const reportGeneratorStartError = (errorText: any) => {
  message.error(errorText);
  return action(ReportsActionTypes.REPORT_GENERATOR_START_ERROR);
};
export const reportGeneratorIsCompleted = (payload: { id: string }) =>
  action(ReportsActionTypes.REPORT_GENERATOR_IS_COMPLETED, payload);

export const reportGeneratorStatusFetchRequest = (payload: { id: string }) =>
  action(ReportsActionTypes.GENERATOR_STATUS_FETCH_REQUEST, payload);
export const reportGeneratorStatusFetchSuccess = (payload: ReportGeneratorState) =>
  action(ReportsActionTypes.GENERATOR_STATUS_FETCH_SUCCESS, payload);
export const reportGeneratorStatusFetchError = (errorText: any) => {
  message.error(errorText);
  return action(ReportsActionTypes.GENERATOR_STATUS_FETCH_ERROR);
};

export const reportGeneratorCancelFetchRequest = (payload: { id: string }) =>
  action(ReportsActionTypes.GENERATOR_CANCEL_FETCH_REQUEST, payload);
